export const START_ZOOM = 1;
export const MAX_ZOOM = 15;
